// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"86277e33","232":"1c9217b4","237":"7113890a","526":"b5766841"}[chunkId] + ".chunk.js";
};